exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes SMBGRangeAnimated--fadein--1Nr5V{0%{fill-opacity:.3}to{fill-opacity:.4}}@keyframes SMBGRangeAnimated--fadeout--2huim{0%{fill-opacity:.4}to{fill-opacity:.3}}.SMBGRangeAnimated--smbgRange--14DpS{fill:var(--trends--light);stroke:none}.SMBGRangeAnimated--fadeIn--3XbzN{animation:SMBGRangeAnimated--fadein--1Nr5V .25s forwards ease-in-out}.SMBGRangeAnimated--fadeOut--2Evdt{animation:SMBGRangeAnimated--fadeout--2huim .25s forwards ease-in-out}", ""]);

// exports
exports.locals = {
	"smbgRange": "SMBGRangeAnimated--smbgRange--14DpS",
	"fadeIn": "SMBGRangeAnimated--fadeIn--3XbzN",
	"fadein": "SMBGRangeAnimated--fadein--1Nr5V",
	"fadeOut": "SMBGRangeAnimated--fadeOut--2Evdt",
	"fadeout": "SMBGRangeAnimated--fadeout--2huim"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/trends/smbg/SMBGRangeAnimated.css
 ** module id = 156
 ** module chunks = 0
 **/